/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubmissionDetailResult } from '../../models/submission-detail-result';

export interface IdpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain$Params {
  submissionId: string;
}

export function idpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain(http: HttpClient, rootUrl: string, params: IdpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionDetailResult>> {
  const rb = new RequestBuilder(rootUrl, idpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('submissionId', params.submissionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubmissionDetailResult>;
    })
  );
}

idpSubmissionGetSubmissionDetailsSubmissionIdGet$Plain.PATH = '/IdpSubmission/GetSubmissionDetails/{submissionId}';
